import WishlistHeaderMenuItem from '@/components/Wishlist/WishlistHeaderMenuItem';
import Tick from "@/assets/svgExports/Tick";
import { IS_DESKTOP } from 'src/utils/checkClientDeviceType';
import PdpShareOptions from '../../SubComponents/ShareOptions';

const WishlistShareButton = ({handleToggleWishlistClick, productData, isItemWishlisted}) => {
    
    return (
        <div className={`tw-w-full tw-mt-[20px] tw-h-[68px] tw-flex tw-items-center tw-border-t tw-border-b tw-border-[#DEDEDE] tw-border-solid tw-font-inter tw-font-medium ${IS_DESKTOP?"tw-gap-50":"tw-gap-25 tw-flex-row-reverse"}`}>
            <div onClick={handleToggleWishlistClick} className={`tw-cursor-pointer tw-w-[180px]`}>
            {isItemWishlisted 
                ? 
                <div className="tw-flex tw-gap-[5px]"><Tick size={25}/> 
                    <span className="tw-flex tw-items-center">Added to Wishlist</span>
                </div> 
                : 
                <WishlistHeaderMenuItem color='black' iconPosition='left' customTextClassName='!tw-text-[16px] !tw-font-medium' ctaText="Add to Wishlist" isActive={false}/>}
            </div>
            {!IS_DESKTOP && <div className="tw-w-[1px] tw-h-[34px] tw-bg-[#DEDEDE]"></div>}
            <div className={`tw-flex tw-items-center tw-cursor-pointer tw-text-[16px]`}>
                <PdpShareOptions productData={productData} showText={true} customWrapperClass={IS_DESKTOP ? "tw-gap-15" : "tw-gap-8 tw-mr-[25px]"}/> 
            </div>
        </div>
    )
}
export default WishlistShareButton;
